import { KeyboardEvent } from 'react';

type Handler = (event: KeyboardEvent<HTMLElement>) => void;

export const onKeyDown = (event: KeyboardEvent<HTMLElement>, handler: Handler) => {
    if (event.key === 'Enter') handler(event);
};
